export default {
  name: "range-slider",
  components: {},
  props: ["value", "disabled"],
  data() {
    return {
      activeMarks: [],
      sliderValue: 0,
      direction: localStorage.getItem("dir")
    };
  },
  computed: {
    sliderTrackWidth() {
      return this.sliderValue + "%";
    }
  },
  mounted() {
    this.sliderValue = this.value;
  },
  methods: {
    updateSlider(event) {
      if (this.sliderValue === parseInt(event.target.value)) {
        this.sliderValue = 0;
      } else {
        this.sliderValue = parseInt(event.target.value);
      }
      this.$emit("update", this.sliderValue);
    }
  }
};
